var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclarationicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 7.5H5.83331C4.4526 7.5 3.33331 8.61929 3.33331 10V15C3.33331 16.3807 4.4526 17.5 5.83331 17.5H14.1666C15.5474 17.5 16.6666 16.3807 16.6666 15V10C16.6666 8.61929 15.5474 7.5 14.1666 7.5Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86667 2.50003H11.125C11.3052 2.49893 11.4838 2.53347 11.6506 2.60166C11.8173 2.66984 11.969 2.77034 12.0968 2.89735C12.2246 3.02437 12.326 3.1754 12.3952 3.34176C12.4644 3.50812 12.5 3.68652 12.5 3.86669V7.50003H7.5V3.86669C7.5 3.50423 7.64399 3.15661 7.90029 2.90031C8.15659 2.64401 8.5042 2.50003 8.86667 2.50003Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 14.1654C10.9205 14.1654 11.6666 13.4192 11.6666 12.4987C11.6666 11.5782 10.9205 10.832 9.99998 10.832C9.07951 10.832 8.33331 11.5782 8.33331 12.4987C8.33331 13.4192 9.07951 14.1654 9.99998 14.1654Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclarationicons);
export default __webpack_public_path__ + "static/media/Declarationicons.f94a2ca9bf4f3970317a0089b4e1abee.svg";
export { ForwardRef as ReactComponent };